import React from 'react';
import { Link } from 'react-router-dom';
import SocialLinks from './SocialLinks';

function Header() {
  return (
    <header className="kg-header">
      <div className="kg-header-left">
        <Link to="/" className="kg-header-logo-link">
          <img src="/logo.png" alt="Kaddera Games" className="kg-header-logo-img" />
          <span className="kg-header-wordmark">Kaddera Games</span>
        </Link>
      </div>

      <div className="kg-header-right">
        <a
          href="https://store.steampowered.com/developer/kadderagames"
          className="kg-header-cta"
          target="_blank"
          rel="noopener noreferrer"
        >
          Steam
        </a>
        <SocialLinks exclude={['steam']} className="kg-header-socials" />
      </div>
    </header>
  );
}

export default Header;
